.related {
}

.heading {
    /* Source text is lowercase ("relatert") so font-variant renders it
       as uniform small caps, matching dibdev. */
    font-variant: small-caps;
    /* A global reset sets `font-synthesis: none`; Lato has no true
       small-cap glyphs, so without re-enabling synthesis small-caps
       silently falls back to plain lowercase. */
    font-synthesis: small-caps;
    font-size: 18px;
    letter-spacing: normal;
    color: #969696;
    font-weight: 600;
    /* Top margin is 15px (not dibdev's 30px) to absorb the 16px
       padding-top on the column wrapper (.related in
       ContentLayoutLEGACY) and land the first heading ~30px from the
       column edge to match dibdev visually. */
    margin: 0 0 15px 0;
    padding-bottom: 0;
    border-bottom: 1px solid #b1b7be;
    line-height: 1.4;
}

.group {
    margin: 0 0 15px;
}

.groupHeading {
    font-size: 19.95px;
    font-weight: 500;
    margin: 0;
    letter-spacing: normal;
    line-height: 1.45;
}

.index {
    color: #fc604f;
}

.tools {
    color: #15a4c1;
}

.sources {
    color: #68a626;
}

.itemList {
    list-style: none;
    margin: 0;
    padding: 0;
}

.itemList li {
    margin-bottom: 7.5px;
}

.itemLink {
    color: rgb(43, 102, 199);
    text-decoration: none;
    font-size: 15px;
    line-height: 1.55;
}

.itemLink:hover {
    text-decoration: underline;
}
